export default {
      id: "case-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#case-usage",
      toString: function () {
        return this.url;
      }
    }